import React, { useState } from 'react';

import Page from 'components/page';
import SectionContainer from 'components/sectionContainer';
import Filters from 'components/filters';
import Updates from 'components/updatesList';
import UpdatesIntro from 'components/updatesIntro';
import { UPDATES_CATEGORIES } from 'context/updates/constants';

const UpdatesPage = ({ location: { hash } }) => {
  let defaultFilter = UPDATES_CATEGORIES[0];
  if (hash) {
    const computedHash = hash.toUpperCase().replace(/#/g, '');
    const filterIndex = UPDATES_CATEGORIES.findIndex(x => x === computedHash);
    defaultFilter = UPDATES_CATEGORIES[filterIndex];
  }
  const [activeFilter, setActiveFilter] = useState(defaultFilter);

  return (
    <Page pageName="updates">
      <SectionContainer>
        <UpdatesIntro />
        <Filters
          options={UPDATES_CATEGORIES}
          onSelect={setActiveFilter}
          selected={activeFilter}
        />
        <Updates filter={activeFilter} />
      </SectionContainer>
    </Page>
  );
};

export default UpdatesPage;
